import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "../../common/useRouter";
import {
    Button,
    Flex,
    Heading,
    Text,
    Image,
    Container,
    Input,
    Checkbox,
    Box, 
    Card
} from "@chakra-ui/react";
import { ApiKey } from "../../common/constant";
import { WebUrl } from "../../routes";
import { setBusy, setIdle, showCustomDialog } from "../../application/action/app_action";
import ApiEngine from "../../common/api-engine";
import { stringIsNullOrEmpty } from "common/util";
import useDatabase, { Table } from "../../hooks/useDatabase";
import { convertBlobArrayDataToBlobUrl, convertBlobDataToFile, convertFileToBlobData } from "../../utils/file";
import { Theme } from "../../constants";
import { ViewIcon, RepeatIcon } from '@chakra-ui/icons'
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { formatDecimal } from "common/util";
import { v4 as uuidv4 } from 'uuid';
import { connect, useDispatch, useSelector } from "react-redux";

/**
 * @author -
 */
function Dashboard() {
    var _router = useRouter();
    const { t } = useTranslation();
    const _dispatch = useDispatch();
    const _IS_LOGGED_IN = useSelector((state) => state.authState.isLoggedIn);
    const _USER_DATA = useSelector((state) => state.authState.userData);


    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Card
                title={'DASHBOARD'}
                justifyContent='center'
                direction='column'
                w='100%'
                mb='0px'>

            </Card>
        </Box>
    );
}

export default Dashboard;